<template>
    
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            total: null,
            trainings: []
        };
    },

    mounted() {
        this.update();
    },

    computed: {
        hasItems() {
            return Object.entries(this.trainings).length > 0;
        }
    },

    methods: {
        update() {
            axios.get('/api/meine-merkliste')
                .then(({data}) => {
                    this.trainings = data.trainings;
                })
        }
    }
}
</script>